import { useNavigate } from 'react-router-dom';
import { BackButton, Container, Content } from './styles';
import logo from '../../assets/logo.svg';
import { BiArrowBack } from 'react-icons/bi';
import { FormEvent, useState } from 'react';
import { toast } from 'react-toastify';
import { apiProd } from '../../services/api';

function Reset() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSwitchToCode(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await apiProd.post('send-mail', {
        email: email,
      });
      if (response.status === 200) {
        toast.success('Email enviado', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        navigate('/recovery-code');
        localStorage.setItem('user', JSON.stringify(response.data.user));
        setEmail('');
      }
      setLoading(false);
    } catch {
      toast.error('Email não encontrado', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
      setLoading(false);
      return;
    }
  }
  return (
    <Container>
      <BackButton onClick={() => navigate(-1)}>
        <BiArrowBack size={32} />
        <span>Voltar</span>
      </BackButton>
      <Content
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        onSubmit={handleSwitchToCode}
      >
        <img src={logo} alt="Logo cdl negocia" />
        <p>
          Confirme seu e-mail para receber o código de recuperação de senha.
        </p>
        <input
          type="email"
          required={true}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="email@email.com.br"
        />
        {loading ? <div className="lds-dual-ring" /> : 
        <button type="submit" disabled={loading ? true : false}>
          Enviar
        </button>
        }
      </Content>
    </Container>
  );
}

export default Reset;
